import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useGetContactsForParticipantContactsParticipantGet } from "@/api-v3";
import { Button } from "@/components/ui/button";
import { ContactsListComponent } from "@/features/support/components/contacts-list";

import { ConfirmationDialog } from "./confirmation-dialog";

interface ForgetPinButtonProps {
  title?: string;
}

export const ForgetPinButton = (props: ForgetPinButtonProps) => {
  const { title } = props;
  const { t } = useTranslation();
  const [openForgottenPinDialog, setOpenForgottenPinDialog] = useState(false);

  const {
    data: contacts,
    isLoading: isContactsLoading,
    isError: isContactsErrored,
  } = useGetContactsForParticipantContactsParticipantGet({
    query: { enabled: openForgottenPinDialog },
  });

  return (
    <>
      {/* Button to trigger dialog */}
      <div className="text-center">
        <Button
          data-testid="forget-pin-button"
          variant="ghost"
          size="sm"
          onClick={() => {
            setOpenForgottenPinDialog(true);
          }}
          type="button"
        >
          {title ?? t("changePin_forgetPin")}
        </Button>
      </div>

      {/* Forgotten PIN Dialog */}
      <ConfirmationDialog
        onOpenChange={setOpenForgottenPinDialog}
        className="max-w-lg"
        label="forgot-pin-dialog"
        open={openForgottenPinDialog}
        title={t("auth_forgotPinAlertTitle")}
        message={
          <ContactsListComponent
            contacts={contacts?.data}
            isLoading={isContactsLoading && !isContactsErrored}
            dataTestId="forgot-pin"
            description={t("auth_forgotPinDescription")}
            variant="list"
          />
        }
        onDismiss={() => {
          setOpenForgottenPinDialog(false);
        }}
        hideConfirmation
        cancelButtonText={t("button_close")}
      />
    </>
  );
};
